// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__qym1c","message":"style__message__awCjQ"};